var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 5.293L5.79301 10.792C5.60572 10.9798 5.50055 11.2343 5.50055 11.4995C5.50055 11.7648 5.60572 12.0192 5.79301 12.207C5.8858 12.2999 5.996 12.3737 6.11732 12.424C6.23863 12.4743 6.36868 12.5002 6.50001 12.5002C6.63134 12.5002 6.76139 12.4743 6.8827 12.424C7.00402 12.3737 7.11422 12.2999 7.20701 12.207L11 8.414V18C11 18.2652 11.1054 18.5196 11.2929 18.7071C11.4804 18.8946 11.7348 19 12 19C12.2652 19 12.5196 18.8946 12.7071 18.7071C12.8947 18.5196 13 18.2652 13 18V8.414L16.793 12.207C16.8859 12.2998 16.9962 12.3735 17.1176 12.4237C17.2389 12.4739 17.369 12.4998 17.5004 12.4997C17.6317 12.4997 17.7618 12.4737 17.8831 12.4234C18.0044 12.3731 18.1147 12.2994 18.2075 12.2065C18.3004 12.1136 18.374 12.0033 18.4242 11.8819C18.4744 11.7606 18.5003 11.6305 18.5002 11.4992C18.5002 11.3678 18.4742 11.2377 18.4239 11.1164C18.3736 10.9951 18.2999 10.8848 18.207 10.792L12.707 5.293C12.6144 5.19983 12.5042 5.12595 12.3829 5.07566C12.2615 5.02536 12.1314 4.99965 12 5C11.8686 4.99965 11.7385 5.02536 11.6171 5.07566C11.4958 5.12595 11.3856 5.19983 11.293 5.293Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.54478bdf.svg";
export { ForwardRef as ReactComponent };